import React, { Component } from "react";

class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <h1>Algo salió mal. Intenta recargar la página.</h1>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
